<div class="loader-container" [class.fixed]="fixed" *ngIf="manualLoading ? isLoading : loaderService.isLoading">
    <div class="loader"></div>
</div>